import React, { useState } from 'react'
import { FAVORITE_STAR_SELECTED, FAVORITE_STAR_UNSELECTED } from '../../../../utils/constants';
import { useSelector } from 'react-redux';

const ToggleFavoritesIcon = ({ handleSetFavorite, isFavoriteBot }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const selectedDomain = useSelector((state) => state.domain.selectedDomain)
    return (
        <>
            <div className="relative">
                <img
                    src={isFavoriteBot ? FAVORITE_STAR_SELECTED : FAVORITE_STAR_UNSELECTED}
                    role="button"
                    className={'cursor-pointer w-[16px]'}
                    onClick={handleSetFavorite}
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                />
                {showTooltip && (
                    <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 z-50 bg-header-bg z-[99999999] rounded-xl">
                        {/* Tooltip content */}
                        <div
                            className={`relative bg-gray-900 text-sm rounded-lg px-3 py-2 shadow-lg whitespace-nowrap transition-opacity duration-200 border  border-gray-700 ${selectedDomain}_font`}
                        >
                            {isFavoriteBot ? "Remove from Favorites" : "Add to Favorites"}

                            {/* Tooltip arrow */}
                            <div className="absolute -top-1.5 left-1/2 transform -translate-x-1/2">
                                <div className="w-0 h-0 border-l-4 border-r-4 border-b-4 border-l-transparent border-r-transparent border-b-gray-900"></div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default React.memo(ToggleFavoritesIcon)